import React, {useState} from 'react';

const LocationDisplay = ({siteData}) => {

	return (
		<div class='diveSites'>
			<div>
				<table>
					{siteData.map(function(site, index) {
						return (
									<tr>
										<td>
											<img alt='logo' src={site.logo} style={{display: site.logo === null?'none':'block'}}  />
										</td>
										<td>
											<p class='siteName'>{site.address_name}</p>
											<p class='phone'>{site.phone_1_no}</p>
											<p class='siteButton'><a href={site.web_url} target='_blank' >VISIT SITE</a></p>
										</td>
									</tr>
						)
					})}
				</table>
			</div>
		</div>
	)
}

export default LocationDisplay